import { EnvironmentProviders, Provider } from '@angular/core';
import { CONSTANTS } from '@core/constants/constants';
import { environment } from '@environments/environment';

import {
  API_URL,
  APP_ID,
  APP_VERSION,
  AUTH_TOKEN,
  CRYPTO_KEY,
  ENVIRONMENT,
  LOCAL_STORAGE,
} from './tokens';

export const provideTokens = (): (Provider | EnvironmentProviders)[] => {
  return [
    { provide: ENVIRONMENT, useValue: environment },
    { provide: AUTH_TOKEN, useValue: CONSTANTS.AUTH_TOKEN },
    { provide: CRYPTO_KEY, useValue: CONSTANTS.CRYPTO_KEY },
    { provide: API_URL, useValue: environment.apiUrl },
    { provide: APP_ID, useValue: environment.appId },
    { provide: APP_VERSION, useValue: environment.appVersion },
    { provide: LOCAL_STORAGE, useValue: localStorage },
  ];
};
